import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Pipe, inject } from '@angular/core';

@Pipe({
  name: 'bypassSecurityTrustHtml',
  standalone: false,
})
export class BypassSecurityTrustHtml {
  protected sanitizer = inject(DomSanitizer);

  public transform(value: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
